export default "__VITE_ASSET__4dd20ca3__"